<template>
  <b-modal
    id="mc-modal-move_gps"
    ref="mc-modal-move_gps"
    :title="$t('setting.list.managementAsset.gps.moveGPS')"
    size="lg"
    centered
    @shown="handleModalShown"
  >
    <div class="card-body">
      <FormulateForm
        ref="formMoveGpsRef"
        v-model="formMoveGps"
        name="form-move-gps"
        @submit="handleSubmit"
      >
        <b-card class="move-gps">
          <b-row>
            <b-col md="3">
              <p class="mc-paragraph">
                {{ $t('setting.list.managementAsset.gps.imei') }}
              </p>
              <h6 class="mc-paragraph">
                {{ imei }}
              </h6>
            </b-col>

            <b-col md="6" class="move-gps__trasnfer">
              <p class="mc-paragraph">
                {{ $t('setting.list.managementAsset.gps.transferTarget') }}
              </p>
              <b-row class="move-gps__display">
                <b-col md="6">
                  <FormulateInput type="group">
                    <div class="form-check form-check-inline">
                      <input
                        id="internal"
                        v-model="transferTarget"
                        class="form-check-input"
                        type="radio"
                        name="transferTargetOptions"
                        :value="'vehicle'"
                      />
                      <label class="form-check-label">{{
                        $t('setting.list.managementAsset.gps.moveVehicle')
                      }}</label>
                    </div>
                  </FormulateInput>
                </b-col>
                <b-col md="6" class="move-gps__radio">
                  <FormulateInput type="group">
                    <div class="form-check form-check-inline">
                      <input
                        id="eksternal"
                        v-model="transferTarget"
                        class="form-check-input"
                        type="radio"
                        :value="'company'"
                        name="transferTargetOptions"
                      />
                      <label class="form-check-label">{{
                        $t('setting.list.managementAsset.gps.moveCompany')
                      }}</label>
                    </div>
                  </FormulateInput>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="3" class="move-gps__license">
              <p class="mc-paragraph">
                {{ $t('setting.list.managementAsset.gps.oldLicensePlate') }}
              </p>
              <h6 class="mc-paragraph">
                {{ licensePlateOld }}
              </h6>
            </b-col>
            <b-col v-if="transferTarget == 'company'" md="3" class="move-gps__company">
              <p class="mc-paragraph">
                {{ $t('setting.list.managementAsset.gps.oldCompanyName') }}
              </p>
              <h6 class="mc-paragraph">
                {{ companyNameOld }}
              </h6>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <FormulateInput
                v-if="transferTarget == 'company'"
                v-model="companyNameSelect"
                type="select-resourceful-v2"
                name="companyNameSelect"
                :label="$t('setting.list.managementAsset.gps.companyName')"
                :placeholder="$t('setting.list.managementAsset.gps.companyName')"
                :trackBy="'companyId'"
                :optionsGetter="resourcefulQuery.companyName"
                :optionLabelFn="({ item }) => item.companyName"
                :fullObject="fullObject.companyName"
                validation="required:trim"
                error-behavior="submit"
                validation-behavior="submit"
                :multiple="false"
                :taggable="false"
                :disabled="isSubmitting"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <FormulateInput
                v-model="licensePlateSelect"
                type="select-resourceful-v2"
                name="licensePlateSelect"
                :label="$t('setting.list.managementAsset.gps.licensePlate')"
                :placeholder="$t('setting.list.managementAsset.gps.licensePlate')"
                :trackBy="'id'"
                :optionsGetter="resourcefulQuery.vehicle"
                :optionLabelFn="({ item }) => item.licensePlate"
                :fullObject="fullObject.licensePlate"
                validation="required:trim"
                error-behavior="submit"
                validation-behavior="submit"
                :multiple="false"
                :taggable="true"
                :disabled="isSubmitting"
                @addTag="tagCustom"
              />
            </b-col>
            <b-col md="6">
              <FormulateInput
                v-model="vehicleTypeSelect"
                type="select-resourceful-v2"
                name="vehicleTypeSelect"
                :label="$t('setting.list.managementAsset.gps.vehicleType')"
                :placeholder="$t('setting.list.managementAsset.gps.vehicleType')"
                :trackBy="'vehicleTypeId'"
                :optionsGetter="resourcefulQuery.vehicleType"
                :optionLabelFn="({ item }) => item.formattedVehicleType"
                :fullObject="fullObject.vehicleType"
                validation="required:trim"
                error-behavior="submit"
                validation-behavior="submit"
                :multiple="false"
                :taggable="false"
                :disabled="isSubmitting || isDisable"
                @addTag="tagCustom"
              />
            </b-col>
            <b-col md="6">
              <FormulateInput
                v-model="phoneNo"
                :label="$t('setting.list.managementAsset.gps.phoneNo')"
                :placeholder="$t('setting.list.managementAsset.gps.phoneNo')"
                type="number"
                :disabled="isSubmitting"
                validation-behavior="submit"
                error-behavior="submit"
                validation="required:trim"
                min="0"
                @keypress="isNumber($event)"
              />
            </b-col>
            <b-col md="6">
              <FormulateInput
                v-model="odometer"
                :label="$t('setting.list.managementAsset.gps.odometer')"
                :placeholder="$t('setting.list.managementAsset.gps.odometer')"
                name="Odometer"
                type="text"
                :disabled="isSubmitting"
                validation-behavior="submit"
                error-behavior="submit"
                validation="bail|required:trim|number|min:0"
                :validation-messages="{
                  min: $t('setting.list.managementAsset.gps.validation.odometer'),
                }"
              />
            </b-col>
            <b-col md="6" class="move-gps__start-date">
              <b-form-group
                id="startSubscription"
                :label="$t('setting.list.managementAsset.gps.startDateSub')"
                class="start-date-sub"
              >
                <date-picker
                  ref="startSubscription-ref"
                  v-model="startSubscription"
                  format="DD MMM YYYY"
                  value-type="YYYY-MM-DD"
                  :placeholder="$t('setting.list.managementAsset.gps.startDateSub')"
                  :class="{
                    'is-invalid': isEmptyStartSubscription,
                  }"
                  :lang="datePickerLang"
                />
                <div class="invalid-feedback">
                  <span v-if="isEmptyStartSubscription">
                    {{ $t('global.validation.required') }}
                  </span>
                </div>
              </b-form-group>
            </b-col>
            <b-col md="6" class="move-gps__end-date">
              <b-form-group
                id="endSubscription"
                :label="$t('setting.list.managementAsset.gps.endDateSub')"
                class="end-date-sub"
              >
                <date-picker
                  ref="endSubscription-ref"
                  v-model="endSubscription"
                  format="DD MMM YYYY"
                  value-type="YYYY-MM-DD"
                  :placeholder="$t('setting.list.managementAsset.gps.endDateSub')"
                  :class="{
                    'is-invalid': isEmptyEndSubscription || isValidDateSub,
                  }"
                  :lang="datePickerLang"
                />
                <div class="invalid-feedback">
                  <span v-if="isEmptyEndSubscription">
                    {{ $t('global.validation.required') }}
                  </span>
                  <span v-else-if="isValidDateSub">
                    {{
                      `${$t('setting.list.managementAsset.gps.endDateSub')} ${$t(
                        'global.validation.min'
                      )} ${$t('setting.list.managementAsset.gps.startDateSub')}`
                    }}
                  </span>
                </div>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
      </FormulateForm>
    </div>
    <template #modal-footer="{ cancel }">
      <div class="d-flex">
        <McButton
          variant="secondary"
          class="me-2"
          :text="$t('global.action.cancel')"
          @click="cancel()"
        />
        <McButton variant="primary" :text="$t('global.action.save')" @click="triggerSubmit" />
      </div>
    </template>
  </b-modal>
</template>
<script>
import { Helper } from '@/mixin/helper'
import McButton from '@/components/McButton'
import datePickerLang from '@/helpers/date-picker-lang'
import { GET_SUB_DOMAINS } from '@/services/api/setting/personalization/domainManagement'
import { GET_VEHICLE } from '@/services/api/master/fleet'
import { GET_VEHICLE_TYPE } from '@/services/api/setting/fleet/fleetType'
import { REASSIGN_IMEI_MUTATION_UPDATE } from '@/services/api/setting/personalization/gps'

export default {
  components: {
    McButton,
  },
  mixins: [Helper],
  props: {
    item: {
      required: true,
    },
  },
  data() {
    return {
      isDisable: false,
      isSubmitting: false,

      initialObject: {
        licensePlate: null,
        companyName: null,
        vehicleType: null,
      },
      licensePlateValue: null,
      licensePlate: [],
      licensePlateSelect: null,
      selectedLicensePlate: null,
      companyName: [],
      companyNameSelect: null,
      companyNameSelectOld: null,
      selectedCompanyName: null,
      vehicleType: [],
      vehicleTypeSelect: null,
      selectedVehicleType: null,
      fullObject: {
        licensePlate: {},
        companyName: {},
        vehicleType: {},
      },
      formMoveGps: {},

      imei: null,
      licensePlateOld: null,
      companyNameOld: null,
      transferTarget: 'vehicle',
      phoneNo: null,
      odometer: null,
      deviceCode: null,
      vendorType: null,
      endSubscription: null,
      startSubscription: null,
      isEmptyEndSubscription: false,
      isEmptyStartSubscription: false,
      isValidDateSub: false,
    }
  },
  computed: {
    resourcefulQuery() {
      return {
        companyName: async (opts) => {
          const searchValue = opts && opts.search ? opts.search : ''
          const filter = {
            orderBy: [JSON.stringify({ name: 'asc' })],
            search: searchValue,
            includeParent: true,
          }
          const res = await this.$apollo.query({
            fetchPolicy: 'no-cache',
            query: GET_SUB_DOMAINS,
            variables: {
              filter: filter,
            },
          })

          const data = res.data.domainManagements.domainManagements.data
          const self = this
          self.companyName = data
          self.initialObject.companyName = self.companyName
          const result = {
            metadata: {
              total_page: 1,
              total_count: 5,
              page: 1,
            },
            data: {
              paginated_result: data,
            },
          }

          return result
        },
        vehicle: async (opts) => {
          const searchValue = opts && opts.search ? opts.search : ''
          const filter = {
            selectedCompanyId: [
              this.companyNameSelect ? this.companyNameSelect : this.getCompanyId(),
            ],
            isHaveDevice: false,
            search: searchValue,
          }
          const res = await this.$apollo.query({
            fetchPolicy: 'no-cache',
            query: GET_VEHICLE,
            variables: {
              filter: filter,
            },
          })

          const data = res.data.vehicles.vehicles
          const self = this
          self.licensePlate = data
          self.initialObject.licensePlate = self.licensePlate
          const result = {
            metadata: {
              total_page: 1,
              total_count: 5,
              page: 1,
            },
            data: {
              paginated_result: data,
            },
          }

          return result
        },
        vehicleType: async (opts) => {
          const searchValue = opts && opts.search ? opts.search : ''
          const filter = {
            companyId: [this.companyNameSelect ? this.companyNameSelect : this.getCompanyId(), 1],
            search: searchValue,
          }
          const res = await this.$apollo.query({
            fetchPolicy: 'no-cache',
            query: GET_VEHICLE_TYPE,
            variables: {
              filter: filter,
            },
          })

          const data = res.data.vehicleTypes.vehicleTypes.data
          const self = this
          self.vehicleType = data
          self.initialObject.vehicleType = self.vehicleType
          const result = {
            metadata: {
              total_page: 1,
              total_count: 5,
              page: 1,
            },
            data: {
              paginated_result: data,
            },
          }

          return result
        },
      }
    },
    datePickerLang() {
      return datePickerLang()
    },
  },

  watch: {
    licensePlateSelect: {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue || newValue === 0) {
          const selected = this.licensePlate.filter((item) => item.id === newValue)
          this.fullObject.licensePlate = selected[0]

          this.selectedLicensePlate = selected[0]

          this.latitude = selected[0].vehicleStatus ? selected[0].vehicleStatus.latitude : 0
          this.longitude = selected[0].vehicleStatus ? selected[0].vehicleStatus.longitude : 0
          this.lastPacket = selected[0].vehicleStatus ? selected[0].vehicleStatus.lastPacket : null
          this.motionStatus = selected[0].vehicleStatus
            ? selected[0].vehicleStatus.motionStatus
            : null
          this.odometer = selected[0] ? selected[0].odometer : null

          this.licensePlateValue = selected[0] ? selected[0].licensePlate : null

          const vehicleTypeId = selected[0] ? selected[0].vehicleTypeId : null

          if (newValue !== 0) {
            const vehicleTypeSelected = selected[0] ? selected[0].vehicleType.type : null
            const opts = {
              search: vehicleTypeSelected,
            }
            this.isDisable = true
            this.resourcefulQuery.vehicleType(opts).then(() => {
              setTimeout(() => {
                this.vehicleTypeSelect = vehicleTypeId
              }, 500)
            })
          }
        } else {
          this.resetField()
        }
      },
    },
    companyNameSelect: {
      deep: true,
      handler(newValue, oldValue) {
        const selected = this.companyName.filter((item) => item.companyId === newValue)
        this.fullObject.companyName = selected[0]

        this.selectedCompanyName = selected[0]
        this.resetField()
      },
    },
    vehicleTypeSelect: {
      deep: true,
      handler(newValue, oldValue) {
        const selected = this.vehicleType.filter((item) => item.vehicleTypeId === newValue)
        this.fullObject.vehicleType = selected[0]

        this.selectedVehicleType = selected[0]
      },
    },
    transferTarget: {
      deep: true,
      handler(newItem) {
        this.companyNameSelect = null
        if (newItem == 'vehicle') {
          this.companyNameSelect = this.companyNameSelectOld
        }
        this.resetField()
      },
    },
    item: {
      deep: true,
      handler(newItem) {
        this.imei = newItem ? newItem.imei : null
        this.licensePlateOld = newItem ? newItem.licensePlate : null
        this.companyNameOld = newItem ? newItem.companyName : null
        this.companyNameSelect = newItem ? newItem.companyId : this.getCompanyId()
        this.companyNameSelectOld = newItem ? newItem.companyId : this.getCompanyId()
        this.deviceCode = newItem ? newItem.deviceCode : null
        this.vendorType = newItem ? newItem.vendorType : null
      },
    },
    startSubscription: {
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.isEmptyStartSubscription = false
        }
      },
    },
    endSubscription: {
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.isEmptyEndSubscription = false
          this.isValidDateSub = false
        }
      },
    },
  },

  methods: {
    handleModalShown() {
      this.transferTarget = 'vehicle'
      this.resetField()
      this.startSubscription = this.item.startSubscription ?? null
      this.endSubscription = this.item.endSubscription ?? null
    },
    resetField() {
      this.isDisable = false
      this.licensePlateSelect = null
      this.vehicleTypeSelect = null
      this.phoneNo = null
      this.odometer = null
      this.licensePlateValue = null
      this.isDisable = false
      this.isEmptyStartSubscription = false
      this.isEmptyEndSubscription = false
      this.isValidDateSub = false
    },
    tagCustom(newTag) {
      this.licensePlate = this.licensePlate.filter((item) => item.id !== 0)

      const tag = {
        licensePlate: newTag,
        id: 0,
      }

      this.licensePlate.push(tag)
      this.licensePlateSelected = tag
      this.fullObject.licensePlate = tag

      this.licensePlateSelect = tag.id
      this.licensePlateValue = tag.licensePlate

      this.isDisable = false
      this.vehicleTypeSelect = null
      this.phoneNo = null
      this.odometer = null
    },
    handleSubmit() {
      const input = {
        imei: this.imei,
        vehicleId: this.licensePlateSelect === 0 ? null : this.licensePlateSelect,
        licensePlate: this.licensePlateValue,
        vehicleTypeId: this.vehicleTypeSelect,
        phoneNo: this.phoneNo,
        odometer: parseFloat(this.odometer),
        domainId: this.companyNameSelect,
        vendorType: this.vendorType,
        deviceCode: this.deviceCode,
        startSubscription: this.startSubscription,
        endSubscription: this.endSubscription,
      }
      this.$apollo
        .mutate({
          mutation: REASSIGN_IMEI_MUTATION_UPDATE,
          variables: {
            input: input,
          },
        })
        .then((response) => {
          if (response) {
            if (!response.data.reassignImei.isSuccessful) {
              let message

              const getMessage = response.data.reassignImei.message.toLowerCase()

              if (getMessage.includes('odometer cannot have a negative value')) {
                message = this.$t('setting.list.managementAsset.gps.message.negativeOdo')
              } else if (getMessage.includes('vehicle does not exist')) {
                message = this.$t('setting.list.managementAsset.gps.message.vehicleNotExist')
              } else if (getMessage.includes('vehicle is not suitable with selected company')) {
                message = this.$t('setting.list.managementAsset.gps.message.vehicleNotSuitable')
              } else if (getMessage.includes('vehicle already has another device')) {
                message = this.$t('setting.list.managementAsset.gps.message.vehicleAlready')
              } else if (
                getMessage.includes('license plate is already registered to another vehicle')
              ) {
                message = this.$t('setting.list.managementAsset.gps.message.licenseAlready')
              } else {
                message = getMessage
              }

              this.$mcToast.warning(message)
              return
            } else {
              this.closeModal()
              this.$mcToast.success(
                this.$t('setting.list.managementAsset.gps.message.successChange')
              )
            }
          }
        })
    },
    closeModal() {
      this.$bvModal.hide('mc-modal-move_gps')
      this.$emit('modalClosed', true)
    },
    triggerSubmit() {
      if (this.startSubscription && !this.endSubscription) {
        this.isEmptyStartSubscription = false
        this.isEmptyEndSubscription = true
        return
      }

      if (this.endSubscription && !this.startSubscription) {
        this.isEmptyStartSubscription = true
        this.isEmptyEndSubscription = false
        return
      }

      if (this.startSubscription && this.endSubscription) {
        if (new Date(this.endSubscription) < new Date(this.startSubscription)) {
          this.isValidDateSub = true
          return
        }
      }

      this.isEmptyStartSubscription = false
      this.isEmptyEndSubscription = false
      this.isValidDateSub = false
      this.$formulate.submit('form-move-gps')
    },
  },
}
</script>
